import {
    IoFolderOpenOutline,
    IoCubeOutline,
    IoListOutline,
    IoLayersOutline,
    IoArrowForwardOutline,
} from "react-icons/io5";
import { Link } from "react-router";
import styled from "styled-components";

import RecentBimClassesAndGeometryTypes from "./RecentBimClassesAndGeometryTypes";
import AppHeader from "../../../../components/AppHeader";
import Search from "../Search";

const StyledIntroDashboard = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin: 0 auto;
    max-width: 1080px;
    min-height: 100vh;
    /* top padding clears the fixed AppHeader pill (top: 16px, ~35px tall) */
    padding: 72px 24px 64px;

    .hero-header {
        display: flex;
        flex-direction: column;
        gap: 8px;

        h1 {
            color: #091e42;
            font-size: 1.8rem;
            font-weight: 700;
            letter-spacing: -0.02em;
            margin: 0;
        }

        p {
            color: #5e6c84;
            font-size: 1rem;
            margin: 0;
        }
    }

    .nav-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 16px;
    }

    .nav-card {
        background: #fff;
        border: 1px solid #e1e4e8;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px;
        text-decoration: none;
        transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

        &:hover {
            border-color: #0052cc;
            box-shadow: 0 8px 16px rgba(9, 30, 66, 0.08);
            transform: translateY(-2px);

            .card-arrow {
                color: #0052cc;
                transform: translateX(4px);
            }
        }

        .card-top {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .card-icon-wrapper {
            align-items: center;
            border-radius: 8px;
            display: flex;
            height: 40px;
            justify-content: center;
            width: 40px;

            svg {
                font-size: 1.35rem;
            }

            &.categories {
                background: #deebff;
                color: #0747a6;
            }
            &.bimclasses {
                background: #e3fcef;
                color: #006644;
            }
            &.parameters {
                background: #ffebe6;
                color: #bf2600;
            }
            &.parameter-groups {
                background: #fffae6;
                color: #974f00;
            }
        }

        .card-title {
            color: #172b4d;
            font-size: 1.1rem;
            font-weight: 600;
        }

        .card-description {
            color: #6b778c;
            font-size: 0.85rem;
            line-height: 1.4;
        }

        .card-footer {
            align-items: center;
            display: flex;
            justify-content: flex-end;
            margin-top: 16px;
        }

        .card-arrow {
            color: #a5adba;
            font-size: 1.1rem;
            transition: transform 0.2s ease, color 0.2s ease;
        }
    }

    .section-block {
        background: #fff;
        border: 1px solid #ebecf0;
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }
`;

export default function Intro() {
    return (
        <StyledIntroDashboard>
            <AppHeader />
            <div className="hero-header">
                <h1>Taxonomy Management</h1>
                <p>Browse, search, and edit BIM categories, classes, parameters, and parameter groups.</p>
            </div>

            <div className="nav-grid">
                <Link className="nav-card" to="Categories">
                    <div className="card-top">
                        <div className="card-icon-wrapper categories">
                            <IoFolderOpenOutline />
                        </div>
                        <div className="card-title">Categories</div>
                        <div className="card-description">Product taxonomy tree and BIM class assignments</div>
                    </div>
                    <div className="card-footer">
                        <IoArrowForwardOutline className="card-arrow" />
                    </div>
                </Link>

                <Link className="nav-card" to="BimClasses">
                    <div className="card-top">
                        <div className="card-icon-wrapper bimclasses">
                            <IoCubeOutline />
                        </div>
                        <div className="card-title">BimClasses</div>
                        <div className="card-description">BIM class definitions, geometry specs, and parameters</div>
                    </div>
                    <div className="card-footer">
                        <IoArrowForwardOutline className="card-arrow" />
                    </div>
                </Link>

                <Link className="nav-card" to="Parameters">
                    <div className="card-top">
                        <div className="card-icon-wrapper parameters">
                            <IoListOutline />
                        </div>
                        <div className="card-title">Parameters</div>
                        <div className="card-description">Property parameters and data type definitions</div>
                    </div>
                    <div className="card-footer">
                        <IoArrowForwardOutline className="card-arrow" />
                    </div>
                </Link>

                <Link className="nav-card" to="ParameterGroups">
                    <div className="card-top">
                        <div className="card-icon-wrapper parameter-groups">
                            <IoLayersOutline />
                        </div>
                        <div className="card-title">Parameter Groups</div>
                        <div className="card-description">Logical groupings for property parameters</div>
                    </div>
                    <div className="card-footer">
                        <IoArrowForwardOutline className="card-arrow" />
                    </div>
                </Link>
            </div>

            <div className="section-block">
                <Search />
            </div>

            <div className="section-block">
                <RecentBimClassesAndGeometryTypes />
            </div>
        </StyledIntroDashboard>
    );
}
